export class BiometricConfig {
    name: string
    displayText: string
    value: string
    type: string
    schoolCd: string
}
